export default __webpack_public_path__ + "static/media/Upload.dcb94999.svg";